import React, {Component} from 'react';
import {InputItem, NavBar, Modal, Toast, ListView, Icon} from 'antd-mobile';
import { getVoteInfo,userVote} from '../../service/homeService';
import "./style.less";
import {weiChatAuthor} from "../../config/config";
import connect from "react-redux/es/connect/connect";
let pageIndex = 1;
let pageSize = 10;
let token = "";
let arr = window.location.search.substring(1).split('?');
function MyBody(props) {
    return (
        <div className="am-list-body my-body">
            <div className="img"><img src={props.voteData.titlePhotograph} /></div>
            <div className="rule">
                {
                    props.voteData.isFinish == 0 ? <div>今日剩余投票次数 <span className="ruleNum">{props.voteData.voteCount}</span></div>: <div style={{color:"#F70000"}}>投票活动已结束</div>
                }

                <div className="look" onClick={()=> Modal.alert(<span style={{"color":"#303030",fontSize:"18px"}}>投票活动规则</span>,
                    <div style={{"color":"#303030",fontSize:"14px",padding:0,maxHeight:300,overflow: "auto",textAlign:"left"}} dangerouslySetInnerHTML = {{ __html:props.voteData.activityContent }}>
                    </div>,[
                        { text: '关闭',},
                    ]
                )}>查看投票规则 <i className="icon iconfont iconwenhao"/></div>
            </div>
            {props.children}
        </div>
    );
}
@connect(
    state => ({userInfo: state.userInfo})
)
export default class Vote extends Component {
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            dataSource,
            isLoading: true,
            data:[
                // {id:1,img:`${img1}`,num:"001",title:"我是最帅的我告诉你",name:"大大大",vote:"4444",},
                // {id:2,img:`${img2}`,num:"002",title:"这里是标题展示，后台尽量字少些",name:"想休息",vote:"6666",},
                // {id:3,img:`${img2}`,num:"002",title:"这里是标题展示，后台尽量字少些",name:"想休息",vote:"6666",},
                // {id:4,img:`${topimg}`,num:"002",title:"这里是标题展示，后台尽量发送到发的发发的所发生的发送到字少些",name:"想休息",vote:"6666",},
            ],
            searchVal:"",
            needFixed:false,
            lookImg:false,
            imgItem:"",
            voteData:"",
        };
    }
    componentDidMount() {
        pageIndex = 1;
        if(document.location.search.indexOf('token=') === -1){
            window.location.href = weiChatAuthor(`vote?id=${arr[0].split('=')[1]}`)
        }else{
            console.log(window.location.href.split('token=')[1])
            token = window.location.href.split('token=')[1];
            this.getData(1);
        }
    }
    getData(pageNum,voteNum){
        let params = {
            source:1,
            token: token,
            data:{
                pageSize: pageSize,
                pageNum: pageNum,
                id:arr[0].split('=')[1],
                voteNum:voteNum,
            },
        };
        getVoteInfo(params).then((res)=>{
            if (res.data.code == "0000") {
                this.setState({voteData:res.data.data});
                this._setDataSource(res.data.data);
            }else {
                Toast.info(res.data.msg,3)
            }
        })
    }
    //数据拼接
    _setDataSource(data) {
        const allData = [...this.state.data, ...data.list];
        this.setState({
            dataSource: this.state.dataSource.cloneWithRows(allData),
            data: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            this.getData(++pageIndex,this.state.searchVal);
        }
    };
    handleScroll =(e)=>{
        let ctx = this;
        let scrollHeight = ctx.refs.bodyBox.scrollTop; //滚动内容高度
        if(scrollHeight >= 200){
            this.setState({ needFixed: true })
        }else{
            this.setState({ needFixed: false })
        }
    };
    bigImg(v){
        this.setState({ lookImg: true,imgItem: v.photograph})
    }
    voteBtn(v){
        let params = {
            source:1,
            token: token,
            data:{
                id:arr[0].split('=')[1],
                voteContentId:v.id,
            },
        };
        if(this.state.voteData.voteCount > 0){
            Toast.loading("");
            userVote(params).then((res)=>{
                Toast.hide();
                if (res.data.code == "0000") {
                    return Modal.alert(<span style={{"color":"#5F698C",fontSize:"20px"}}>投票成功!</span>,<div style={{"color":"#303030",fontSize:"16px",padding:0}}> 关注民途出行公众号，首单立减20元</div>, [
                        { text: '取消', onPress:()=>window.location.reload(), style:{"color":"#9A9B9B",fontSize:"16px"}},
                        { text: '去关注', onPress: () => window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI1ODc5NDgzNw==&scene=124#wechat_redirect' ,style:{"color":"#3679FE",fontSize:"16px"},},
                    ])
                }else{
                    Toast.info(res.data.msg,3)
                }
            })
        }else{
            return Modal.alert(<span style={{"color":"#F70000",fontSize:"20px"}}>投票次数已用完</span>,<div style={{"color":"#303030",fontSize:"16px",padding:0}}><p style={{"color":"#616372",fontSize:"14px",fontWeight:"initial",lineHeight:"26px"}}>今日投票次数已用完，记得明日再来哟</p> 关注民途出行公众号，首单立减20元</div>, [
                { text: '取消',style:{"color":"#9A9B9B",fontSize:"16px"}},
                { text: '去关注', onPress: () => window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI1ODc5NDgzNw==&scene=124#wechat_redirect' ,style:{"color":"#3679FE",fontSize:"16px"},},
            ])
        }

    }
    search(){
        this.lv.scrollTo(0, 0);
        pageIndex = 1;
        this.setState({data:[],isLoading:true});
        this.getData(1,this.state.searchVal);
    }
    render(){
        if(token == ""){
            return null
        }
        const _renderRow = (res, index, rowID) => (
            <div className="listItem" key={index}>
                <div className="top">
                    <img src={res.photograph} onClick={()=>this.bigImg(res)}/>
                    <div className="label">{res.voteNum}</div>
                </div>
                <div className="bottom">
                    <div className="title" style={{"WebkitBoxOrient": "vertical"}}>{res.title}</div>
                    {
                        this.state.voteData.isFinish == 0 ?  <div className="text"><span className="userName">{res.userName}</span>得票数:<span className="ruleNum">{res.count}</span></div>:
                            <div className="text"><span className="userName">{res.userName}</span>排名:<span className="ruleNum">{parseInt(rowID)+1}</span></div>
                    }
                </div>
                {
                    this.state.voteData.isFinish == 0 ? (
                        <div className="voteBtn" >
                            <button onClick={()=>this.voteBtn(res)}><i className="icon iconfont icontoupiao"/> 投 票</button>
                        </div>
                    ):null
                }

            </div>
        );
        return(
            <div className="voteBox">
                <NavBar
                    className="navBar"
                    mode="light"
                    // icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >{this.state.voteData.activityThemeName}</NavBar>
                <div  className="searchBox" >
                    <div  className="search">
                        <i className="icon iconfont iconsousuokuang"/>
                        <InputItem
                            onChange={(v)=>this.setState({searchVal:v})}
                            placeholder="输入编号搜索"
                        >
                        </InputItem>
                    </div>
                    <span onClick={()=>this.search()}>搜 索</span>
                </div>
                <div className="content"  onScroll={this.handleScroll} ref="bodyBox">
                    <ListView
                        className="list"
                        ref={el => this.lv = el}
                        dataSource={this.state.dataSource}
                        renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                        renderRow={_renderRow}
                        style={{
                            height: '100%',
                            overflow: 'auto',
                        }}
                        onEndReached={this._onEndReached.bind(this)}
                        scrollRenderAheadDistance={300}
                        onEndReachedThreshold={50}
                        renderBodyComponent={() => <MyBody voteData={this.state.voteData}/>}
                    />
                </div>
                <Modal
                    className="lookImgModal"
                    visible={this.state.lookImg}
                    transparent
                    onClose={()=>this.setState({lookImg:false})}
                >
                    <img src={this.state.imgItem} />
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Vote/index.js